import { render, staticRenderFns } from "./OffsetTable2.vue?vue&type=template&id=0612e9f4&"
import script from "./OffsetTable2.vue?vue&type=script&lang=js&"
export * from "./OffsetTable2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports